import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { Cached } from '@material-ui/icons'
import { makeStyles, Input, Tooltip, styled } from '@material-ui/core'

import StyledSVG from '../shared/StyledSVG'

import groupMessageSVG from '../../assets/icons/message-group.svg'
import searchIcon from '../../assets/icons/search-icon.svg'

const useStyles = makeStyles(theme => ({
  root: {
    height: '68vh',
    overflowY: 'auto'
  },
  room_participants_selected: {
    backgroundColor: '#E9FAD9 !important'
  },
  message_section: {
    cursor: 'pointer',
    display: 'flex',
    gap: 8,
    padding: '8px 8px',
    borderRadius: 8
  },
  room_participants: {
    borderRadius: 8,
    backgroundColor: '#F5F6F7',
    padding: 8
  },
  message_preview: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflowX: 'auto'
  },
  message_preview_info: {
    display: 'flex',
    flexDirection: 'column',
    '& h1': {
      color: '#555555',
      fontWeight: 500,
      fontSize: 14,
      margin: 0
    },
    '& span.description': {
      color: '#9F9F9F',
      fontWeight: 400,
      fontSize: 12,
      margin: 0
    }
  },
  chat_info_label: {
    backgroundColor: '#ADB8CC66',
    width: 'fit-content',
    borderRadius: 4,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 8px',
    '& span': {
      margin: 0,
      fontSize: 10,
      fontWeight: 400,
      color: '#666666'
    }
  },
  chat_name: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  pending_view: {
    width: 16,
    height: 16,
    borderRadius: '100%',
    border: '1px solid #F69E9E',
    color: '#F69E9E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  search_component: {
    marginTop: '8px',
    marginBottom: '12px',
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  infiniteScroll: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    overFlowX: 'hidden'
  }
}))

const InputWrapper = styled('div')(({ theme, jstContent }) => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  alignItems: 'center',
  justifyContent: jstContent
}))

const GroupRoomMenuMessages = props => {
  const {
    clearGroupRooms,
    getChats,
    groupRooms,
    roomMenu,
    handleClickRoom,
    match
  } = props
  const classes = useStyles()
  const [inputValue, setInputValue] = React.useState('')
  const showCachedIcon =
    roomMenu.current_room_type === 0 && roomMenu.current_destination !== 1

  const truncate = (text, limit) => {
    return text?.length > limit ? `${text.slice(0, limit)}...` : text
  }

  const handleSearchRoom = () => {
    clearGroupRooms()
    getChats({
      page: 1,
      params: {
        'q[name_cont]': inputValue
      }
    })
  }
  return (
    <div id={'sidebarScrollable'} className={classes.root}>
      <InputWrapper jstContent={showCachedIcon ? 'space-between' : 'flex-end'}>
        {roomMenu.current_room_type === 0 &&
          roomMenu.current_destination !== 1 && (
            <Cached
              onClick={() => {
                clearGroupRooms()
                getChats({ page: 1 })
              }}
              className={classes.reload_rooms}
            />
          )}
        <Input
          disableUnderline
          className={classes.search_component}
          placeholder='Busque pelo nome do grupo'
          onChange={event => setInputValue(event.target.value)}
          onKeyDown={event => {
            handleSearchRoom()
          }}
          value={inputValue}
          startAdornment={
            <StyledSVG
              style={{ marginRight: 4 }}
              src={searchIcon}
              width={18}
              height={18}
            />
          }
        />
      </InputWrapper>
      <InfiniteScroll
        dataLength={groupRooms.items.length}
        scrollableTarget={'sidebarScrollable'}
        next={() => {
          if (!groupRooms.isFetching) {
            getChats({
              page: groupRooms?.pagination?.page + 1,
              params: {
                ...(inputValue.length > 0 ? { 'q[name_cont]': inputValue } : {})
              }
            })
          }
        }}
        loader={<h4>Carregando...</h4>}
        className={classes.infiniteScroll}
        hasMore={
          groupRooms.isFetching
            ? true
            : groupRooms.pagination.total > groupRooms.items.length &&
              groupRooms.items.length !== 0
        }
        endMessage={
          <p style={{ textAlign: 'center' }}>
            <b>Todos os grupos carregados.</b>
          </p>
        }
      >
        {groupRooms.items.length > 0 &&
          groupRooms.items.map((item, index) => {
            const tooltipMessage = item?.last_message
              ? `Última mensagem: ${item?.last_message_author} - ${
                  item.last_message.content?.length > 0
                    ? truncate(item.last_message.content, 500)
                    : 'Mensagem sem conteúdo textual'
                }`
              : ''
            return (
              <Tooltip
                key={`${item.id}${index}`}
                title={tooltipMessage}
                leaveDelay={50}
                placement='right'
                disableFocusListener
                disableInteractive
              >
                <div
                  onClick={() => handleClickRoom(item.id)}
                  key={`${item.id} ${Math.random()}`}
                  className={` ${classes.message_section} ${
                    classes.room_participants
                  } ${
                    +match?.params?.chatId === +item.id
                      ? classes.room_participants_selected
                      : ''
                  }`}
                >
                  {item.cover_image_url ? (
                    <img
                      src={item.cover_image_url}
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 50
                      }}
                    />
                  ) : (
                    <StyledSVG src={groupMessageSVG} width={40} height={40} />
                  )}
                  <div className={classes.message_preview}>
                    <div className={classes.message_preview_info}>
                      <div className={classes.chat_name}>
                        <h1>{item?.name}</h1>
                        {item?.pending_messages_count > 0 && (
                          <div className={classes.pending_view}>
                            {item?.pending_messages_count}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={classes.chat_info_label}>
                      <span>{`${
                        item?.room_participants?.length
                      } membros`}</span>
                    </div>
                  </div>
                </div>
              </Tooltip>
            )
          })}
      </InfiniteScroll>
    </div>
  )
}

export default GroupRoomMenuMessages
